import * as Sentry from '@sentry/vue';
export default class {
  constructor(option) {
    this.standards = {
      strict: 'strict',
      loose: 'loose',
      html5: 'html5'
    };
    this.selectArray = []; // select 요소를 저장하는 배열
    this.counter = 0;
    this.settings = {
      standard: this.standards.html5,
      extraHead: '', // head 태그에 추가할 요소들, 쉼표로 구분
      extraCss: '', // 추가할 CSS 링크들, 쉼표로 구분
      popTitle: '', // 타이틀 제목
      endCallback: null, // 인쇄 후 호출되는 콜백 함수
      ids: '', // 부분 인쇄를 위한 ID
      selectedLv1PrintOption: []
    };
    Object.assign(this.settings, option);

    this.init();
  }

  // 초기화 함수
  init() {
    const printAreaComponent =
      document.querySelector('#full-report-preview-sb') ||
      document.querySelector('#full-report-preview') ||
      document.querySelector('#assurance-preview');

    if (printAreaComponent && printAreaComponent.parentElement) {
      const printAreaClassList = printAreaComponent.parentElement.classList;

      if (
        document.querySelector('#full-report-preview-sb') ||
        document.querySelector('#full-report-preview')
      ) {
        printAreaClassList.remove('d-none');
        printAreaClassList.add('invisible');
      }

      this.waitForResources(printAreaComponent).then(() => {
        this.counter++;
        this.settings.id = `printArea_${this.counter}`;
        const PrintAreaWindow = this.getPrintWindow(); // iframe 생성
        this.write(PrintAreaWindow.doc); // 내용 작성
        this.print(PrintAreaWindow);

        setTimeout(() => {
          if (
            document.querySelector('#full-report-preview-sb') ||
            document.querySelector('#full-report-preview')
          ) {
            printAreaClassList.remove('invisible');
            printAreaClassList.add('d-none');
          }
          if (this.settings.endCallback && typeof this.settings.endCallback === 'function') {
            this.settings.endCallback();
          }
        }, 3000);
      });
    } else {
      console.error('printAreaComponent 또는 그 parentElement를 찾을 수 없습니다.');
      return;
    }
  }

  waitForResources(element) {
    return new Promise(resolve => {
      const checkInterval = 500;
      const maxWaitTime = 30000; // 최대 30초
      let elapsedTime = 0;

      const intervalId = setInterval(() => {
        const images = Array.from(element.querySelectorAll('img'));
        const allImagesLoaded = images.every(img => img.complete);

        if (allImagesLoaded || elapsedTime >= maxWaitTime) {
          clearInterval(intervalId);
          // 렌더링 안정화를 위해 1초 추가 대기
          setTimeout(resolve, 1000);
        }

        elapsedTime += checkInterval;
      }, checkInterval);
    });
  }

  // 인쇄 함수
  print(PAWindow) {
    const paWindow = PAWindow.win;
    const _loaded = () => {
      paWindow.focus();

      // 프린트 시 파일명 설정을 위해 잠시 타이틀 변경
      const originalTitle = document.title;
      if (this.settings.popTitle) {
        document.title = this.settings.popTitle;
      }

      paWindow.print();

      // 타이틀 원복
      if (this.settings.popTitle) {
        document.title = originalTitle;
      }

      try {
        const box = document.getElementById(this.settings.id);
        box.parentNode.removeChild(box);
      } catch (error) {
        Sentry.captureException(new Error('[프린트 canvas 삭제] ' + error.message));
      }
    };

    if (window.ActiveXObject) {
      _loaded();
      return false;
    }

    paWindow.onload = () => {
      _loaded();
    };
  }

  // 문서 작성 함수
  write(PADocument, $ele) {
    PADocument.open();

    // Create html element
    const html = PADocument.createElement('html');
    html.lang = 'ko';

    // Create head
    const head = PADocument.createElement('head');
    head.innerHTML = this.getHead();
    html.appendChild(head);

    // Create body
    const body = PADocument.createElement('body');
    body.innerHTML = this.getBody();
    html.appendChild(body);

    PADocument.appendChild(html);

    // 페이지 번호 업데이트 스크립트 추가
    const script = PADocument.createElement('script');
    script.textContent = `
      (function() {
        window.onload = function() {
          var pageNumbers = document.querySelectorAll('.pageNum');
          pageNumbers.forEach(function(el, index) {
            el.textContent = index + 1;
          });
        };
      })();
    `;
    PADocument.body.appendChild(script);

    PADocument.close();
  }

  // DOCTYPE 설정 함수
  docType() {
    if (this.settings.standard === this.standards.html5) {
      return '<!DOCTYPE html>';
    }
    const transitional = this.settings.standard === this.standards.loose ? ' Transitional' : '';
    const dtd = this.settings.standard === this.standards.loose ? 'loose' : 'strict';

    return `<!DOCTYPE HTML PUBLIC "-//W3C//DTD HTML 4.01${transitional}//EN" "http://www.w3.org/TR/html4/${dtd}.dtd">`;
  }

  // head 태그 생성 함수
  getHead() {
    let extraHead = '';
    let links = '';
    let style = '';
    if (this.settings.extraHead) {
      this.settings.extraHead.replace(/([^,]+)/g, m => {
        extraHead += m;
      });
    }

    // 모든 link 태그 복사
    document.querySelectorAll('link[rel="stylesheet"]').forEach(item => {
      if (item.href && item.href.indexOf('.css') >= 0) {
        links += `<link type="text/css" rel="stylesheet" href="${item.href}" >`;
      }
    });

    // 내부 스타일시트만 복사
    const domStyle = document.styleSheets;
    if (domStyle && domStyle.length > 0) {
      for (let i = 0; i < domStyle.length; i++) {
        try {
          // 크로스오리진 스타일시트는 건너뛰기
          if (domStyle[i].href && new URL(domStyle[i].href).origin !== window.location.origin) {
            continue;
          }
          if (domStyle[i].cssRules || domStyle[i].rules) {
            const rules = domStyle[i].cssRules || domStyle[i].rules;
            for (let b = 0; b < rules.length; b++) {
              style += rules[b].cssText;
            }
          }
        } catch (error) {
          Sentry.captureException(new Error('[프린트 canvas 복제] ' + error.message));
        }
      }
    }

    if (this.settings.extraCss) {
      this.settings.extraCss.split(',').forEach(m => {
        links += `<link type="text/css" rel="stylesheet" href="${m.trim()}">`;
      });
    }

    let lv1TopNameCSS = ``;

    const lv1_title_list = Array.isArray(this.settings.selectedLv1PrintOption)
      ? this.settings.selectedLv1PrintOption.map(info => info.name)
      : [];

    for (const lv1_title of lv1_title_list) {
      const sanitizedTitle = lv1_title
        .trim()
        .replace(/[\n\r]+/g, '')
        .replace(/\s+/g, '_');
      lv1TopNameCSS += `
        @page ${sanitizedTitle} {
          @top-right {
            content: " ${lv1_title}";
            font-size: 13px;
            font-family: pretendard;
            color: #333333;
            margin-right: 1cm;
          }

        }
      `;
    }

    // 페이지 번호를 위한 CSS 추가
    const pageNumberCSS = `
    <style type="text/css">
      @media print {
        @page {
          @top-left {
            content: "${this.settings.popTitle}";
            font-size: 13px;
            font-family: Pretendard, sans-serif;
            color: #333333;
            margin-left: 1cm;
          }
          @bottom-right {
            content: counter(page)  ;
            font-size: 13px;
            font-family: pretendard;
            color: #666666;
            margin-right: 1cm;
            margin-left: 1cm;
            border-top: 1px solid #999999;
          }
        }
        @page :first {
          @top-left {
            content: none;
          }
          @top-right {
            content: none;
          }
          @bottom-right {
            content: none;
          }
        }

        @page secondPage {
          @top-left {
            content: none;
          }
          @top-right {
            content: none;
          }
          @bottom-right {
            content: none;
          }
        }

        ${lv1TopNameCSS}
        
        body {
          counter-reset: page;
        }

      }
    </style>
  `;

    return `
      <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>${this.settings.popTitle}</title>
        ${extraHead}
        ${links}
        <style type="text/css">${style}</style>
        ${pageNumberCSS}
      </head>
    `;
  }

  // body 태그 생성 함수
  getBody() {
    let ids = this.settings.ids;
    ids = ids.replace(new RegExp('#', 'g'), '');

    this.elsdom = this.beforeHandler(document.getElementById(ids));
    const ele = this.getFormData(this.elsdom);

    // First Page Content
    let firstPageContent = '';
    const firstPageElement = ele.querySelector('.first-page');
    if (firstPageElement) {
      firstPageContent = firstPageElement.outerHTML;
    }

    // Second Page Content
    let secondPageContent = '';
    const secondPageElement = ele.querySelector('.second-page');
    if (secondPageElement) {
      secondPageElement.style.pageBreakBefore = 'always';
      secondPageElement.style.page = 'secondPage';
      secondPageContent = secondPageElement.outerHTML;
    }

    // Other Elements
    const otherElements = Array.from(ele.children).filter(child => {
      return !child.classList.contains('first-page') && !child.classList.contains('second-page');
    });

    for (const otherElement of otherElements) {
      otherElement.style.page = otherElement.classList[0];
    }

    const htm = otherElements.map(child => child.outerHTML).join('');

    return `
      <body>
        ${firstPageContent}
        ${secondPageContent}
        ${htm}
      </body>
    `;
  }

  // Canvas가 제대로 렌더링되었는지 확인하는 함수들
  isCanvasRendered(canvas) {
    const ctx = canvas.getContext('2d');
    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    return imageData.data.some(pixel => pixel !== 0);
  }

  hasValidDimensions(canvas) {
    return (
      canvas.width > 0 && canvas.height > 0 && canvas.offsetWidth > 0 && canvas.offsetHeight > 0
    );
  }

  getRenderedCanvas(canvasList) {
    return Array.from(canvasList).find(canvas => {
      // 1. 크기 확인
      if (!this.hasValidDimensions(canvas)) return false;

      // 2. DOM에서 보이는 상태인지 확인
      if (canvas.offsetParent === null) return false;

      // 3. 실제 렌더링된 내용이 있는지 확인
      try {
        return this.isCanvasRendered(canvas);
      } catch (e) {
        return false;
      }
    });
  }

  // 노드를 복제하기 전에 수행할 작업
  beforeHandler(elsdom) {
    const canvasList = elsdom.querySelectorAll('canvas');
    // canvas를 png 이미지로 변환
    for (let i = 0; i < canvasList.length; i++) {
      try {
        const canvas_id = canvasList[i].id.split('chart_canvas_')[1];

        // 잘 렌더링 된 캔버스 고르기
        const sameIdCanvasList = document.querySelectorAll(
          `canvas[id*="chart_canvas_${canvas_id}"]`
        );
        let selectedCanvas = canvasList[i];

        if (sameIdCanvasList.length > 1) {
          selectedCanvas = this.getRenderedCanvas(sameIdCanvasList) || canvasList[i];
        }

        const _parent = canvasList[i].parentNode;
        const _canvasUrl = selectedCanvas.toDataURL('image/png', 0.7);
        const _img = new Image();
        _img.className = 'canvasImg';
        // _img.style.display = 'none';
        _img.src = _canvasUrl;
        // 캔버스를 이미지로 교체
        _parent.replaceChild(_img, canvasList[i]);
      } catch (error) {
        console.log(error);
      }
    }

    return elsdom;
  }

  // form 데이터를 처리하는 함수
  getFormData(ele) {
    const copy = ele.cloneNode(true);
    const copiedInputs = copy.querySelectorAll('input,select,textarea');
    const canvasImgList = copy.querySelectorAll('.canvasImg,canvas');
    let selectCount = -1;

    // 모든 <a> 태그의 href 속성을 절대 경로로 변환
    const links = copy.querySelectorAll('a');
    for (let i = 0; i < links.length; i++) {
      const item = links[i];
      const href = item.getAttribute('href');
      if (href) {
        item.setAttribute('href', new URL(href, window.location.href).href);
        item.setAttribute('target', '_blank');
      }
    }

    // 모든 canvas 요소 처리
    for (let i = 0; i < canvasImgList.length; i++) {
      const _parent = canvasImgList[i].parentNode;
      const item = canvasImgList[i];
      if (item.tagName.toLowerCase() === 'canvas') {
        _parent.removeChild(item);
      } else {
        item.style.display = 'inline-block';
        item.style.width = '100%';
      }
    }

    // 모든 입력 요소 처리
    for (let i = 0; i < copiedInputs.length; i++) {
      const item = copiedInputs[i];
      let typeInput = item.getAttribute('type');
      const copiedInput = copiedInputs[i];

      if (!typeInput) {
        typeInput =
          item.tagName === 'SELECT' ? 'select' : item.tagName === 'TEXTAREA' ? 'textarea' : '';
      }

      if (item.tagName === 'INPUT') {
        if (typeInput === 'radio' || typeInput === 'checkbox') {
          if (item.checked) {
            copiedInput.setAttribute('checked', item.checked);
          }
        } else {
          copiedInput.value = item.value;
          copiedInput.setAttribute('value', item.value);
        }
      } else if (typeInput === 'select') {
        selectCount++;
        for (let b = 0; b < ele.querySelectorAll('select').length; b++) {
          const select = ele.querySelectorAll('select')[b];
          !select.getAttribute('newbs') && select.setAttribute('newbs', b);
          if (select.getAttribute('newbs') == selectCount) {
            const opSelectedIndex = ele.querySelectorAll('select')[selectCount].selectedIndex;
            item.options[opSelectedIndex].setAttribute('selected', true);
          }
        }
      } else {
        copiedInput.innerHTML = item.value;
        copiedInput.setAttribute('html', item.value);
      }
    }

    return copy;
  }

  // 인쇄 창을 생성하는 함수
  getPrintWindow() {
    const f = this.Iframe();
    return {
      f: f,
      win: f.contentWindow || f,
      doc: f.doc
    };
  }

  // iframe을 생성하는 함수
  Iframe() {
    const frameId = this.settings.id;
    let iframe;
    const that = this;
    try {
      iframe = document.createElement('iframe');
      document.body.appendChild(iframe);
      iframe.style.border = '0px';
      iframe.style.position = 'absolute';
      iframe.style.width = '0px';
      iframe.style.height = '0px';
      iframe.style.right = '0px';
      iframe.style.top = '0px';
      iframe.setAttribute('id', frameId);
      iframe.setAttribute('src', 'about:blank');
      iframe.doc = null;
      iframe.doc = iframe.contentDocument
        ? iframe.contentDocument
        : iframe.contentWindow
        ? iframe.contentWindow.document
        : iframe.document;
      iframe.onload = function () {
        const win = iframe.contentWindow || iframe;
        that.print(win);
      };
    } catch (error) {
      Sentry.captureException(new Error('[프린트 iframe 생성] ' + error.message));
      throw new Error(
        '[프린트 iframe 생성] ' + error.message + '. iframes may not be supported in this browser.'
      );
    }

    if (iframe.doc == null) {
      throw new Error('Cannot find document.');
    }

    return iframe;
  }
}
